/**
 * Admin Content Page: landing for content section (feedback, pastor, church).
 */

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Layout } from "../../../components/layout/index.ts";
import {
  IconChevronRight,
  IconMessage,
  IconEnvelope,
  IconMapPin,
  IconHomeHeart,
  IconDove,
} from "../../../components/Icons.tsx";
import { getTelegram, haptic } from "../../../lib/telegram.ts";
import { useAuth } from "../../../lib/auth.tsx";

export function AdminContentPage() {
  const navigate = useNavigate();
  const tg = getTelegram();
  useAuth();

  useEffect(() => {
    if (!tg) return;
    tg.BackButton.show();
    const handleBack = () => {
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate("/admin");
      }
    };
    tg.BackButton.onClick(handleBack);
    return () => {
      tg.BackButton.offClick(handleBack);
      tg.BackButton.hide();
    };
  }, [tg, navigate]);

  return (
    <Layout>
      <div className="pb-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-xl bg-slate-100 flex items-center justify-center text-slate-600">
            <IconMessage className="w-6 h-6" />
          </div>
          <div className="flex-1 min-w-0">
            <h1 className="text-xl font-bold text-slate-900">Контент</h1>
            <p className="text-[13px] text-slate-500">
              Обратная связь, пастор, о церкви
            </p>
          </div>
        </div>

        <div className="card overflow-hidden">
          <button
            type="button"
            onClick={() => {
              haptic("light");
              navigate("/admin/content/feedback");
            }}
            className="w-full flex items-center gap-3 min-h-[72px] px-4 py-3 active:bg-slate-50 transition-colors text-left"
          >
            <div className="w-11 h-11 rounded-xl bg-slate-100 flex items-center justify-center flex-shrink-0">
              <IconMessage className="w-5 h-5 text-slate-600" />
            </div>
            <div className="flex-1 min-w-0">
              <span className="font-semibold text-slate-900 text-[15px] block truncate">
                Обратная связь
              </span>
              <span className="text-[12px] text-slate-500">
                Сообщения пользователей
              </span>
            </div>
            <IconChevronRight className="w-5 h-5 text-slate-300 flex-shrink-0" />
          </button>

          <button
            type="button"
            onClick={() => {
              haptic("light");
              navigate("/admin/content/pastor");
            }}
            className="w-full flex items-center gap-3 min-h-[72px] px-4 py-3 active:bg-slate-50 transition-colors text-left border-t border-slate-100"
          >
            <div className="w-11 h-11 rounded-xl bg-slate-100 flex items-center justify-center flex-shrink-0">
              <IconEnvelope className="w-5 h-5 text-slate-600" />
            </div>
            <div className="flex-1 min-w-0">
              <span className="font-semibold text-slate-900 text-[15px] block truncate">
                Написать пастору
              </span>
              <span className="text-[12px] text-slate-500">
                Настройка и сообщения
              </span>
            </div>
            <IconChevronRight className="w-5 h-5 text-slate-300 flex-shrink-0" />
          </button>

          <button
            type="button"
            onClick={() => {
              haptic("light");
              navigate("/admin/content/church");
            }}
            className="w-full flex items-center gap-3 min-h-[72px] px-4 py-3 active:bg-slate-50 transition-colors text-left border-t border-slate-100"
          >
            <div className="w-11 h-11 rounded-xl bg-slate-100 flex items-center justify-center flex-shrink-0">
              <IconMapPin className="w-5 h-5 text-slate-600" />
            </div>
            <div className="flex-1 min-w-0">
              <span className="font-semibold text-slate-900 text-[15px] block truncate">
                О церкви
              </span>
              <span className="text-[12px] text-slate-500">
                Текст, контакты, реквизиты
              </span>
            </div>
            <IconChevronRight className="w-5 h-5 text-slate-300 flex-shrink-0" />
          </button>

          <button
            type="button"
            onClick={() => {
              haptic("light");
              navigate("/admin/content/home-groups");
            }}
            className="w-full flex items-center gap-3 min-h-[72px] px-4 py-3 active:bg-slate-50 transition-colors text-left border-t border-slate-100"
          >
            <div className="w-11 h-11 rounded-xl bg-rose-50 flex items-center justify-center flex-shrink-0">
              <IconHomeHeart className="w-5 h-5 text-rose-600" />
            </div>
            <div className="flex-1 min-w-0">
              <span className="font-semibold text-slate-900 text-[15px] block truncate">
                Домашние группы
              </span>
              <span className="text-[12px] text-slate-500">
                Текст и картинка страницы
              </span>
            </div>
            <IconChevronRight className="w-5 h-5 text-slate-300 flex-shrink-0" />
          </button>

          <button
            type="button"
            onClick={() => {
              haptic("light");
              navigate("/admin/content/welcome");
            }}
            className="w-full flex items-center gap-3 min-h-[72px] px-4 py-3 active:bg-slate-50 transition-colors text-left border-t border-slate-100"
          >
            <div className="w-11 h-11 rounded-xl bg-teal-50 flex items-center justify-center flex-shrink-0">
              <IconDove className="w-5 h-5 text-teal-600" />
            </div>
            <div className="flex-1 min-w-0">
              <span className="font-semibold text-slate-900 text-[15px] block truncate">
                Welcome Page
              </span>
              <span className="text-[12px] text-slate-500">
                Посадочная страница /welcome
              </span>
            </div>
            <IconChevronRight className="w-5 h-5 text-slate-300 flex-shrink-0" />
          </button>
        </div>

        <div className="h-6" />
      </div>
    </Layout>
  );
}
